var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip } from '../BaseComponents/Tooltip';
import styled, { useTheme } from 'styled-components';
import { useApplication } from '../../Contexts/ApplicationContext';
var StyledSVG = styled.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 14px;\n  height: 14px;\n  align-self: center;\n"], ["\n  width: 14px;\n  height: 14px;\n  align-self: center;\n"])));
var InfoIcon = function () {
    var theme = useTheme();
    return (_jsx(StyledSVG, __assign({ width: "14px", height: "14px" }, { children: _jsx("path", { d: "M6.33301 8.99992H7.66634V10.3333H6.33301V8.99992ZM6.33301 3.66659H7.66634V7.66659H6.33301V3.66659ZM6.99301 0.333252C3.31301 0.333252 0.333008 3.31992 0.333008 6.99992C0.333008 10.6799 3.31301 13.6666 6.99301 13.6666C10.6797 13.6666 13.6663 10.6799 13.6663 6.99992C13.6663 3.31992 10.6797 0.333252 6.99301 0.333252ZM6.99967 12.3333C4.05301 12.3333 1.66634 9.94659 1.66634 6.99992C1.66634 4.05325 4.05301 1.66659 6.99967 1.66659C9.94634 1.66659 12.333 4.05325 12.333 6.99992C12.333 9.94659 9.94634 12.3333 6.99967 12.3333Z", fill: theme.colors.textBodyAdd }) })));
};
export var TotalFeeInfoIcon = function () {
    var fee = useApplication().orderFacade.exchangeInfo.fee;
    var feeDetailsTextContent = function () {
        if (!fee) {
            return [_jsx(_Fragment, {})];
        }
        return fee.details.map(function (detail) {
            var capitalizedProvider = detail.provider.charAt(0).toUpperCase() +
                detail.provider.slice(1).toLowerCase();
            return (_jsxs("p", __assign({ style: { margin: 0 } }, { children: [capitalizedProvider, ": ", detail.amount, " ", detail.currency] }), capitalizedProvider));
        });
    };
    return (_jsx(_Fragment, { children: (fee === null || fee === void 0 ? void 0 : fee.details) && fee.details.length > 1 && (_jsx(Tooltip, __assign({ content: feeDetailsTextContent() }, { children: _jsx(InfoIcon, {}) }))) }));
};
var templateObject_1;
